import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { TaglineContainer, TaglineText, FirstPart, Comma, SecondPart } from './Tagline.styles';
import { TaglineProps } from './Tagline.types';

const Tagline: React.FC<TaglineProps> = React.memo(({ className }) => {
  const { t } = useI18n();

  return (
    <TaglineContainer className={className}>
      <TaglineText>
        <FirstPart>{t('tagline.firstPart')}</FirstPart>
        <Comma>,</Comma>
        <SecondPart> {t('tagline.secondPart')}</SecondPart>
      </TaglineText>
    </TaglineContainer>
  );
});

Tagline.displayName = 'Tagline';

export default Tagline;
